var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showModal,
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm.showPlayer ? _c('div', {
    staticClass: "video-player-container"
  }, [_c('video-player')], 1) : _vm._e(), _vm.showProgress ? _c('div', {
    staticClass: "progressScreen"
  }, [_c('progress-path')], 1) : _vm._e(), _vm.showCertificate ? _c('div', {
    staticClass: "certScreen"
  }, [_c('certificate')], 1) : _vm._e(), _vm.showError ? _c('div', {
    staticClass: "errorScreen"
  }, [_c('oops', {
    attrs: {
      "hide-tell-teacher": _vm.modalData && _vm.modalData.hideTellTeacher
    }
  })], 1) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }